import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import useAuth from '../hooks/useAuth';
import { PATH_DASHBOARD } from '../routes/paths';
import LoadingScreen from '../components/LoadingScreen';
import useUserInvitation from '../hooks/useUserInvitation';
import useCarbonUser from '../hooks/useCarbonUser';
import useSubscriptions from 'src/hooks/useSubscriptions';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { carbonUser } = useCarbonUser();
  const { isUserInvited } = useUserInvitation();
  const { subscriptionsAreLoading, currentPlan } = useSubscriptions();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated && !isUserInvited && carbonUser?.merchantUsers?.length) {
    if (subscriptionsAreLoading) {
      return <LoadingScreen />;
    }

    return <Navigate to={currentPlan ? PATH_DASHBOARD.root : PATH_DASHBOARD.user.plans} />;
  }

  return <>{children}</>;
}
